import InfoButton from '../../../components/InfoButton/InfoButton'
import ComingSoon from '../../../components/ComingSoon/ComingSoon'
import '../Section.css'

function WhoSitsWhere() {
  return (
    <div className="dashboard-section">
      <h1>
        Who Sits Where
        <InfoButton
          title="Who Sits Where"
          content={
            <div>
              <p>
                Assign guests to tables by number. Create your seating chart and make sure everyone has a seat 
                (yes, even Uncle Bob). Mix personalities thoughtfully — your college roommate doesn't need to sit with your boss.
              </p>
              <p>
                <strong>Features:</strong>
              </p>
              <ul>
                <li>Create tables and assign seat numbers</li>
                <li>Drag and drop guests to tables</li>
                <li>View table capacity and occupancy</li>
                <li>Print seating chart and place cards</li>
                <li>Simple table view (no complex graphic design needed)</li>
              </ul>
              <p>
                Seating chart magic — done right, without the stress.
              </p>
            </div>
          }
        />
      </h1>
      <ComingSoon messageIndex={4} />
    </div>
  )
}

export default WhoSitsWhere
